// extracted by mini-css-extract-plugin
module.exports = {"title":"TripTabList_title__1l7un","list":"TripTabList_list__1yygI","dot":"TripTabList_dot__2NRX1","active":"TripTabList_active__1zLo6","general":"TripTabList_general__GFOT7"};